import ApiService from './ApiService'
import { LINXFOUR_MASTER_USER_ID, LINXFOUR_SHORT_NAME } from '@/data/constants'

function _setLinxfourEmailToUserEmail({ data }) {
    if (!data || !data.email || !data.lists || !data.lists.oem) {
        return data?.lists?.oem || {}
    }

    const { email } = data
    const { oem } = data.lists

    if (typeof email !== 'string' || typeof oem !== 'object' || oem === null) {
        return oem || {}
    }

    let linxfourKey = null
    let linxfourValue = null
    const otherEntries = {}

    for (const [key, value] of Object.entries(oem)) {
        if (Number(value) === LINXFOUR_MASTER_USER_ID) {
            linxfourKey = LINXFOUR_SHORT_NAME
            linxfourValue = value
        } else {
            otherEntries[key] = value
        }
    }

    const updatedOem = {}
    if (linxfourKey) {
        updatedOem[linxfourKey] = linxfourValue
    }
    Object.assign(updatedOem, otherEntries)

    return updatedOem
}

const AuthService = {
    login(credentials) {
        return ApiService.post('vue_login', credentials)
    },

    loginInternal(credentials) {
        return ApiService.post('internal_login', credentials)
    },

    register(userData, invite) {
        return ApiService.post('invited_submit', userData, invite)
    },

    internalRegister(userData, invite) {
        return ApiService.post('internal_invite_submit', userData, { internal_invite: invite })
    },

    forgotPassword(email) {
        return ApiService.post('password.email', { email })
    },

    resetPassword(email, token, password, passwordConfirmation) {
        return ApiService.post('password.update', {
            email,
            token,
            password,
            password_confirmation: passwordConfirmation,
        })
    },

    async logout() {
        try {
            const response = await ApiService.post('/app/vue_logout')
            return response
        } catch (error) {
            console.error('Logout failed:', error)
            throw error
        }
    },

    async getAuthenticatedUser() {
        const response = await ApiService.get('/app/user_data')
        if (!response.data.lists.oem) {
            return response
        }

        response.data.lists.oem = _setLinxfourEmailToUserEmail(response)
        return response
    },
}

export default AuthService
